export enum RowSelectorMode {
  NONE = "none",
  SINGLE = "single",
  MULTIPLE = "multiple",
}